export default "__VITE_ASSET__f6dcfe88__"